





































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { OrdersResp_Order, PrInternalStatus } from '@/apiv3/index'
import auth from '@/auth'
import { MessageService, messages } from '@/api'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import helpers from '@/helpers'
import OrdersList from './OrdersList.vue'

@Component({ components: { PulseLoader, OrdersList } })
export default class Main extends Vue {
  public orders: OrdersResp_Order[] = []
  public blocked = false
  public loadedOrders = false
  public loadedMessages = false
  public msgs: messages = []
  public PrInternalStatus = PrInternalStatus

  mounted () {
    auth.adminClient().Orders({}).then((resp) => {
      this.orders = resp.orders
      this.loadedOrders = true
    })

    MessageService.getUserMessagesUnread().then((resp) => {
      this.msgs = resp.items
      this.loadedMessages = true
    })
  }

  formatDate (val: string | undefined): string {
    return helpers.formatDate(val)
  }

  ordersFiltered (status: PrInternalStatus): OrdersResp_Order[] {
    const filtered: OrdersResp_Order[] = []

    this.orders.forEach(val => {
      if (val.internalStatus === status) {
        filtered.push(val)
      }
    })

    return filtered
  }
}
